module.exports = __webpack_public_path__ + "img/LUB00381.3967f62d.png";